<template>
  <div>
    <div class="tw-flex tw-gap-2 tw-mb-3">
      <div class="tw-font-bold">{{ $t("status") }}:</div>
      <cl-pill
        v-if="incident"
        :variant="mapUiStatusToStatusLabelStyle(incident.ui_status)"
        class="tw-flex tw-items-center"
      >
        {{ incident.ui_status }}
      </cl-pill>
      <div v-else>-</div>
    </div>
    <div class="tw-flex tw-gap-2 tw-mb-3">
      <div class="tw-font-bold">{{ $t("flag-reason") }}:</div>
      <div v-if="incident">
        {{ incident.ui_flag_reason }}
      </div>
      <div v-else>-</div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { mapUiStatusToStatusLabelStyle } from "@/modules/PhishTitan/utils";
import { useIncidents } from "../useIncidents.store";

const { incidentDetails: incident } = useIncidents();
</script>
